<template>
  <v-row no-gutters style="justify-content:center">
    <template v-for="skill in skills">
      <v-col cols="12" sm="3" :key="skill" style="margin:10px;">
        <v-card elevation="3">
          <v-card-title class="flexinall">
            <div>{{ skill[0] }}</div>
            <div>{{ skill[1] }}</div>
          </v-card-title>
          <v-progress-linear
            height="10"
            :value="skill[1]"
            rounded
            striped
            color="#"
            class="styledbar"
            :style="{ background: skill[2] }"
          ></v-progress-linear>
          <br />
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      skills: [
        ["Flask", "85%", "#00bcd4"],
        ["NodeJs", "60%", "#ff5722"],
        ["Express", "60%", "#9c27b0"],
        ["Tkinter", "65%", "#3f51b5"],
        ["Wordpress", "50%", "#28a745"],
      ],
    };
  },
};
</script>

<style scoped>
.styledbar {
  background: #ff5722;
  width: 90%;
  margin: auto;
}
.flexinall {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: inherit; */
}
</style>
